module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "chapter-number-only",
    attrs: {
      "id": "_idParaDest-7",
      "lang": "en-US"
    }
  }, [_vm._v("CHAPTER THREE")]), _vm._v(" "), _c('p', {
    staticClass: "chapter-subtitle",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("MILA KINSLOW")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("(Excerpted from interview #MC1803/D)")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Los Angeles was a huge disappointment.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I was expecting palm trees and sunny beaches and sidewalks filled with pretty people waiting for their close-ups. But there wasn’t any palm trees at the bus station and the sun looked like a soggy yellow cotton ball floating around behind a big gray curtain of smog. On top of that, at least a month went by before I even found out which direction the ocean was in, and another month after that before I ever laid my eyes on it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I didn’t complain or fuss about it though.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Alexandra and I talked the whole way out from Flagstaff, and by the time we got to California she knew my entire sorry drama. She told me that her friends called her Sandi, and that’s what I should call her too.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sandi with an ‘i’,” she said, and I remember laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She offered to let me stay with her and her two roommates in a tiny house they all rented a few blocks over from the Sunset Strip, said I could make a bed out on the living room couch until I got my feet set on the ground. Sandi made a couple of calls and even got me a job—two jobs, really—answering phones at a bail bond place during the daytime, and waiting tables at a twenty-four-hour diner at night. Sandi and her roommates didn’t ask me to pay rent for the first whole month after I got there, just asked me to pitch in when the groceries ran low.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("All three of the girls were in their early twenties, but none of them seemed to care that I was so much younger. They treated me like a little sister, I guess, assuming sisters teach you how to drink beer and smoke marijuana. I never had no sisters, not even any cousins, so I don’t really know. We laughed a lot, though, and cried sometimes if we got too drunk, but mostly it was nice, and on weekends they’d sneak me into the music clubs along the Strip, where nobody seemed to care at all how old I was.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("That’s where I met Jack McCall.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I should have known right away he was going to be bad news, him having the exact same name as the sonofabitch who murdered Wild Bill Hickok. I never did do all that well at school back home, but I always did pretty good in history because I liked it, and I especially liked hearing about cowboys, so some stuff kind of stuck in my head like that.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Anyways, the Jack McCall I’m talking about was a guitar player and singer in a band called Hammerhead that played at the Whisky a Go Go. Their music was sort of heavy blues, and I met him the night they opened up for Rory Gallagher. God, but Jack was pretty then; sweet, soulful blue eyes and long, curly blond hair that would hang down in front of his face when he got lost in a song. This was, what, two years ago, so it was 1973 at the time and I hadn’t even turned eighteen yet.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Sandi got us in for free because she had a friend who played bass in the band, so we all hung out together when Hammerhead finished with their set, and she introduced me to the guys. Like I said before, Jack McCall was movie-star good looking, and he liked his girlfriends young, so within a couple of months I’d moved my stuff out of Sandi’s rental house and started shacking-up with Jack.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Sandi’s friend the bass player would crash with Jack and me from time to time, and he was real nice to me too. Never tried anything with me, always acted like an old-fashioned gentleman where I was concerned. His name was Peter Troy, but everyone knew him as Sweet Pete.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Seventy-three turned out not to be a very good year on the Strip. Record companies that used to send untested acts out on the road to gain experience couldn’t afford to do it anymore, so clubs weren’t putting on live shows as much as they had before. Some of them locked up their doors for good. It seemed like the whole country had fallen into a funk, and nobody had any money. Jack would go days sometimes without leaving the apartment; spent his time laying on the sofa and watching the guys on the news talk about oil embargoes and Watergate and the war, or plinking on his guitar with the amp turned way down low. I didn’t know it at the time, but that’s when Jack took up with the needle.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I was young and stupid then, and never saw the signs. Until I finally did.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("One night we were all together at the Whisky to watch Hammerhead open up for Buddy Miles. I was drinking beers at the bar with Sandi that night—they never asked me for ID—when the whole room watched Jack McCall implode onstage. When it was over, I heard one of the bartenders say, “I’m not sure the lead singer’s supposed to stagger around and weep into the microphone through the whole damn show, is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I didn’t want to go backstage during the break. I didn’t know what I should do. A half hour later, Sweet Pete came out and plopped down in the barstool next to mine with a look on his face like somebody had just shot his dog.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He’s going to hurt you, Mila,” he told me.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I told him that Jack wasn’t a violent man.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I didn’t mean he would hurt you by his own hand,” he said. “But he’s circling the drain and he doesn’t give a shit if he takes everybody with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I was so mad at Pete for saying something like that, I couldn’t even look at his face.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Grow up, goddamn it, Mila,” Pete said. “Jack’s a fucking junkie.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Don’t you say things like that,” I finally said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t think I can do this much longer,” Pete said while I peeled the label off my beer bottle and pretended to ignore him. “I’ve got a friend who knows this guy up in Oregon. He’s got a big ass bunch of land with lots of groovy people living there.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I asked Pete what the hell he was talking about. I was still mad at him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You and I could drive there together, Mila,” was all he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I spent the next three days at Sandi’s house because I didn’t want to go back home to Jack. It was kinda like old times at Sandi’s place, except it also kinda wasn’t. Hammerhead wasn’t working anywhere, and the whole scene had started to get pretty depressing. My mind kept drifting back to Tennessee, even though I had no mind to ever go back. I guess that’s what feeling homesick is. I had been raised going to church. Sunday school from the time I could walk. I even sang in the children’s cherub choir. But lately I had found myself wondering if there was such a thing as God, or as a soul, and if there was, how could you explain a man like Jack McCall and what he was doing to all of us.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I finally decided to go back to our apartment after my shift at the diner, having stupidly convinced myself that I could be Jack’s savior. I found him laying face down on the couch wearing nothing but those striped bell-bottomed pants he hadn’t even bothered to zip up all the way. I shook him by the shoulder and he rolled onto the floor. His lips were crusted with flecks of vomit and dried blood, one of his eyes had swollen like an eggplant and one of his front teeth was busted off clear down to the gum. His torso was marbled with bruises and his breath smelled like spoiled dog food. He tried to smile at me, and when he did I felt exactly like I had that night back at the truck stop.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I couldn’t help it, and I started crying, more for Jack than for myself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I asked him what had happened to him and he told me it was a misunderstanding about a money thing.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“How much?” I asked him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“More than either of us has got, darlin’.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I got so mad I could have hit him, but I didn’t. For all the vain and weak and selfish things Jack was, he never laid a hand on me in anger, so I wasn’t going to be the one to do it to him. Besides, there wasn’t much of him that hadn’t already been abused.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You don’t get to call me that anymore,” I told him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He began to shiver and I could see then that he was dope sick. The whites of his eyes had turned the color of worn-out old piano keys, and the veins stood out on his arms like night crawlers that had up and died in there.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I need a favor from you, baby,” he said. “Just this one time.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m not buying smack for you,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His mouth made a dry clicking sound when he tried to speak next and he could no longer look me in the eye.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s not that,” he said. “There’s two guys. You’ve seen them before at the Whisky.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I told you I won’t help you kill yourself, Jack. I mean it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was still seated on that filthy rug, propped up against the sofa cushion. He shook his head and looked up at me with his one good eye.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They want you to join them for a party,” he said. “They said they’ll clear my debt if you go.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I heard the hiss of air brakes from a city bus outside on the street, and the dying-dog howl of a police siren from somewhere in the distance.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Christ, Jack,” I whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I need this from you, baby,” he said. “You love me, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I could only stare, couldn’t have said anything if I wanted to.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I love you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You love me?” I said. I wanted to scream then. I wanted to kick him. Mostly I wanted to curl up in a ball and disappear. “You want to pimp me out to two strangers for a fix.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Baby—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I never heard the rest of what he said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("All I remember is that it seemed like the walls were folding in and I was weightless, and pinwheels started spinning in my head. My heart was slamming and my blood felt like it was boiling inside, and my thoughts were nothing but a confused tangle of pitiful emotions. I had heard words like heartbreak and fury, and I thought I knew what they meant. Turns out I had no idea until that night. I knew that hell must have been left unattended in that moment because the devil and all his demons had surely been set loose in LA.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I don’t remember how I got there, but I ended up standing at Sweet Pete’s door.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Have you still got that friend in Oregon, Pete?”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b3b492f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504081696-7.vue
// module id = 93
// module chunks = 0